export const FLORA_SUPPORT_ASSETS = {
	eyesClosed: '/flora-support/flora-eyes-closed.png',
	eyesOpen: '/flora-support/flora-eyes-open.png',
	close: '/flora-support/flora-close.png',
} as const;

export const FLORA_SUPPORT_SUGGESTIONS = [
	'Como cadastrar propriedade',
	'Como enviar análise PDF para cadastro',
	'Como criar parcelamento',
] as const;

export const FLORA_SUPPORT_COPY = {
	title: 'Suporte Practium',
	subtitle: 'Online · resposta em poucos minutos',
	placeholder: 'Descreva o que você precisa de ajuda...',
	disclaimer: 'A Flora pode cometer erros. Por isso, é bom checar as respostas.',
	fabOpenLabel: 'Abrir suporte Flora',
	fabCloseLabel: 'Fechar suporte Flora',
	optionsLabel: 'Abrir opções do suporte',
	minimizeLabel: 'Minimizar suporte',
	clearSessionLabel: 'Limpar sessão',
	sendLabel: 'Enviar mensagem',
} as const;
